// Libraries
import React from 'react'
import I18n from 'i18next'
import moment from 'moment'
import { Tooltip } from 'antd'
import { isNil, get } from 'lodash'

// Global components
import { Anchor } from 'Components'

// Helpers
import { cropWithExtension } from 'Helpers'

// Helpers
import {
  dateSort,
  alphaSort,
  periodSort,
  filterPeriod
} from 'Components/TableLayout/Helpers'

const specs = {
  // Nom des éléments affichés et listés
  element: {
    name: 'scan',
    kind: 'male'
  },

  // Liste des boutons du tableau
  actions: {
    // Actions sur l'ensemble du tableau
    global: {
      create: {
        label: 'common.add',
        icon: 'plus'
      }
    },
    // Actions groupées sur les lignes du tableau
    selection: {
      delete: {
        buttonType: 'danger'
      }
    }
  },

  // Gestion de l'internationalisation
  locale: {
    emptyText: 'pages.scans.table.empty'
  },

  // Affichage du titre
  titleEnabled: true,

  // Affichage de la zone de recherche
  searchEnabled: true,

  // Render custom des en-têtes
  renderHeaderLeft: null,
  renderHeaderRight: null,

  // Gestion de la pagination
  pagination: {
    position: 'both',
    showSizeChanger: true,
    pageSizeOptions: ['10', '25', '50', '100']
  },

  // Identifiant unique de chaque ligne du tableau
  rowKey: 'id',

  // Colonnes du tableau
  columns: {
    name: {
      title: 'pages.scans.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      render: (name, scan) =>
        !isNil(name) ? (
          <Anchor
            onClick={e => {
              e.stopPropagation()
              window.open(get(scan, 'url'), '_blank')
            }}
          >
            {cropWithExtension(name, 40)}
          </Anchor>
        ) : (
          I18n.t('common.unknown.male')
        ),
      sorter: (...params) => alphaSort(params, 'name')
    },
    validityPeriod: {
      title: 'pages.scans.fields.validityPeriod.title',
      dataIndex: 'validityPeriod',
      key: 'validityPeriod',
      render: validityPeriod =>
        !isNil(validityPeriod) ? (
          <span className='period'>
            <span className='period-date'>
              {moment(get(validityPeriod, 'startDate')).format('L')}
            </span>
            <span className='period-date'>
              {moment(get(validityPeriod, 'endDate')).format('L')}
            </span>
          </span>
        ) : (
          I18n.t('common.unknown.female')
        ),
      sorter: (...params) =>
        periodSort(params, [
          'validityPeriod.startDate',
          'validityPeriod.endDate'
        ]),
      ...filterPeriod(null, moment(), [
        'validityPeriod.startDate',
        'validityPeriod.endDate'
      ])
    },
    dateCreated: {
      title: 'pages.scans.fields.dateCreated.title',
      dataIndex: 'dateCreated',
      key: 'dateCreated',
      render: dateCreated =>
        !isNil(dateCreated) ? (
          <Tooltip title={moment(dateCreated).format('L')}>
            {moment(dateCreated).calendar()}
          </Tooltip>
        ) : (
          I18n.t('common.unknown.female')
        ),
      sorter: (...params) => dateSort(params, 'dateCreated'),
      defaultSortOrder: 'descend',
      ...filterPeriod(null, moment(), 'dateCreated')
    }
  }
}

export default specs
